import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { CalendarComponentOptions } from 'ion2-calendar';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { Chart } from 'chart.js';

/**
 * Generated class for the KasiyerBazliRaporPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-kasiyer-bazli-rapor',
  templateUrl: 'kasiyer-bazli-rapor.html',
})
export class KasiyerBazliRaporPage {
  @ViewChild('sideNavUrunAra') sideNav;
  @ViewChild('chartCanvas') chartCanvas;
  SlsMan: string="";
  Kasa: string = "";
  Tutar:number=0;
  chartVar: any;
  tarih1: any;
  tarih2: any;
  raporlar: any = { ToplamNakit: "" };
  RaporListesi: any = {};
  hataMesaji = "";
  sonucYok: boolean = true;
  sonucVar: boolean = false;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "primary",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
     public navParams: NavParams) {
      this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
      this.tarih2 = this.tarih1;
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    this.gunsonurapor();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  dope() {
    this.Tutar += 1;
    this.showChart();
  }
  showChart() {
    this.chartVar = new Chart(this.chartCanvas.nativeElement, {
      type: 'pie',
      data: {
        datasets: [{
          data: [
            this.Tutar,
           // this.Pos,
            //this.VeresiyeTutar
          ],
          backgroundColor: [
            'rgba(30,144,255)',
            'rgba(205,51,51)',
            'rgba(255,228,19)'
          ]
        }],
        labels: [
          'Nakit',
          'Kredi Kartı',
          'Veresiye Satış'
        ]
      },
      options: {
        tooltips: {
          enabled: true
        }
      }
    })
  }
  gunsonurapor() {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
  
    this.bllOrtak.islem(formData, "KasiyerBazliRapor", "", true).then(a => {
      var sonuc = <any>a;
      
      this.RaporListesi = sonuc.SonucObject;
 
      this.Tutar = 0;

      this.RaporListesi.forEach(element => {
        this.Tutar = parseFloat(element.Tutar.toString());
    
        this.showChart()
      })
    })
    this.closeNav();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/kasiyer-bazli-rapor/kasiyer-bazli-rapor.ts